import React, { ReactNode } from 'react'
import { Wrapper, TabMenus, TabButton } from './styled'
import { LabelSemiBoldMedium } from 'components/base-ui/FontsV2'

export interface TabSetting {
  key: string
  title: string
  children: ReactNode
}

export interface TabsProps {
  tabs: TabSetting[]
  activeTab: string
  onSelectTab: (key: string) => void
  hideTabButton?: boolean
}

const Tabs = ({ tabs, activeTab, onSelectTab, hideTabButton = false }: TabsProps) => {
  return (
    <Wrapper>
      {!hideTabButton && (
        <TabMenus>
          {tabs.map((tab) => (
            <TabButton key={tab.key} active={tab.key === activeTab} onClick={() => onSelectTab(tab.key)}>
              <LabelSemiBoldMedium color="primary">{tab.title}</LabelSemiBoldMedium>
            </TabButton>
          ))}
        </TabMenus>
      )}

      {renderChildren()}
    </Wrapper>
  )

  function renderChildren() {
    const selectedTab = tabs.find((tab) => tab.key === activeTab)
    if (selectedTab) return selectedTab.children
    return null
  }
}

export default Tabs
